import { render, staticRenderFns } from "./BarLabel.vue?vue&type=template&id=51d368b1&scoped=true&"
import script from "./BarLabel.vue?vue&type=script&lang=js&"
export * from "./BarLabel.vue?vue&type=script&lang=js&"
import style0 from "./BarLabel.vue?vue&type=style&index=0&id=51d368b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d368b1",
  null
  
)

export default component.exports